import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BaseNavLink } from '@hdms/shared/page-frame/types';

@Component({
  selector: 'shrd-pf-ui-user-account-links',
  templateUrl: './header-user-account-links.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserAccountLinksComponent {
  @Input() links: BaseNavLink[];
}
